module.exports = __webpack_public_path__ + "img/share-solid.328a1136.svg";